import React, { Component } from 'react'
import cx from 'classnames'
import { Layout, Container, Header } from 'src/components/Layout'
import { Link } from 'src/components/Button'
import * as Sentry from '@sentry/browser';

import styles from './ErrorBoundary.module.less'
import { logError } from 'src/utils/helpers'

export default class ErrorBoundary extends Component {
  state = {
    hasError: false
  }

  componentDidCatch(error, errorInfo) {
    try {
      // Display fallback UI
      this.setState({ hasError: true });

      try {
        logError('ErrorBoundary debugging', {
          error: error,
          errorName: error.name,
          errorMessage: error.message,
          errorInfo: errorInfo,
          isOffline: this.isOffline(),
        }, 0)
      } catch (e) {
        logError('ErrorBoundary debugging caught error', e, 0)
      }


      // TODO: PAT-2665 Figure out how to prevent kiosk from crashing when internet connection is not stable
      //  it should already read files from Service Worker so this might be fine


      // TODO: PAT-2665 Handle this: SyntaxError: Unexpected token '<' which is probably when we release new version,
      //  so old chunk (e.g. '/static/js/55.8b8d6420.chunk.js') is replaces with new one and old path returns HTML,
      //  because of that strange thing in /server/app.js - app.get('*') -> index.html


      // Reload the page if actual build file doesn'te exist (JS/CSS etc.)
      if(error.hasOwnProperty('name') && error.name === 'KioskServerMissingStaticFile') {
        this.reload()
        return false
      }

      // Skip posting to Sentry on ChunkLoadError, because this can happen when internet connection is breaking
      if(error.hasOwnProperty('name') && error.name === 'ChunkLoadError' && this.isOffline() === true) {
        logError('Skip posting to Sentry on ChunkLoadError when offline', error, 1)
        return false
      }

      Sentry.withScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key]);
        });
        Sentry.captureException(error);
      });
    } catch (e) {
      logError('ErrorBoundary caught error', e, 1)
    }
  }

  /**
   * Clearing cache/precache might solve some issues if old version got stuck in the Service Worker.
   */
  clearCacheAndReload = () => {
    const { clearAppCache } = this.props

    if(typeof clearAppCache === 'function') {
      clearAppCache()
    }

    this.reload()
  }

  isOffline = () => {
    try {
      return this.props.isOffline.online !== true
    } catch (e) {
      return false
    }
  }

  reload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {

      const buttonClassNames = cx({
        'kiosk-color--primary-color': true,
        'kiosk-color--primary-color-hover': true,
      })

      return (
        <Layout className={styles.layout}>
          <Header
            onBack={this.clearCacheAndReload}
            hideBackText={true}
            title="Oops!"
          />
          <Container padder>
            <h2>Something went wrong, please try again.</h2>

            <div className={styles.resetBtnHolder}>
              <Link
                className={buttonClassNames}
                onClick={this.clearCacheAndReload}
              >Click here to reset</Link>
            </div>

            {Sentry && typeof Sentry !== 'undefined' && typeof Sentry.showReportDialog === 'function' ? (
              <Link
                className={buttonClassNames}
                onClick={() => Sentry.showReportDialog()}
              >Report a feedback</Link>
            ) : ''}
          </Container>
        </Layout>
      );
    }

    return this.props.children;
  }
}
